class AgencyAuthModel {
  constructor({ id, name, belong, permission }) {
    this.id = id
    this.advertiserAuths = []
    this.name = name
    this.belong = belong
    this.isChanged = false
    this.permission = permission
  }
  addAdvertiserAuths(advertiserAuth) {
    this.advertiserAuths.push(advertiserAuth)
  }
  getPermission() {
    // permissionがviewのときは、noneと返す
    if (this.permission === 'view') return 'none'
    // それ以外のときは、permissionをそのまま返す
    return this.permission
  }

  setPermission(permission) {
    this.isChanged = true
    // permissionを適切な形にして代入する
    this.permission = this._calcAppropriatePermission(permission)
  }

  // 設定するpermissionについて、以下のいずれかの条件を満たす場合はviewに変更する
  _calcAppropriatePermission(permission) {
    // permissionを'none'に変更しようとしているときに
    if (permission === 'none') {
      // 変更しようとしているのが自分自身の権限 or 子要素にreadonly以上の子供がいる場合
      // 'view'に変更
      if (this.belong === true || this._hasReadonlyChildren()) return 'view'
    }
    return permission
  }

  /**
   *  readonly以上の子が1つでもあるどうかを判定する
   *  いる場合はtrue, いない場合はfalseを返す
   */
  _hasReadonlyChildren() {
    const adv = this.advertiserAuths.find((adv, index, advs) => {
      return adv.isMoreReadonly() === true
    })
    if (adv === undefined) return false
    return true
  }

  // 子供から通知があった時、permissionがnoneのときはviewにする
  notify() {
    if (this._hasReadonlyChildren()) {
      // permissionがnoneで、子供にreadonly以上がいるときはviewになる
      if (this.getPermission() === 'none') this.permission = 'view'
    } else {
      // permissionがviewで、子供にreadonly以上がいないときはnoneになる
      if (this.permission === 'view') this.permission = 'none'
    }
  }
}

export default AgencyAuthModel
